import { useTranslation } from "react-i18next";
import { ChartCard, InfoCard } from "../../components";
import { Box } from "@mui/material";
import { infoCardData, chartData, xLabels } from "./mock-data";
import { useStyles } from "./style";
import { TimeRangeToggles } from "../../components";

export const Dashboard = () => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <Box>
      <Box className={classes.title}>{t("dashboard.title")}</Box>

      <Box className={classes.container}>
        <Box className={classes.innerContainer}>
          <Box className={classes.miniTitle}>{t("dashboard.overview")}</Box>
          <TimeRangeToggles />
        </Box>
        <Box className={classes.cardsContainer}>
          {infoCardData.map((info) => (
            <InfoCard key={info.label} label={info.label} value={info.value} />
          ))}
        </Box>
        <Box className={classes.chartsContainer}>
          {chartData.map((chart) => (
            <ChartCard
              key={chart.title}
              title={chart.title}
              series={chart.series}
              xLabels={xLabels}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
